import React from 'react';
import TableV3 from '../../../../components/generic/Table/TableV3';
import { Button, Footer, TitleBar } from '../../../../components';
import { useNavigate, useParams } from 'react-router';
import { useLocationBusinessFunctionWorkarounds } from './hooks';
import { useLocationName } from '../../../../hooks';
import { overviewColumns } from '../shared/workarounds';
import { tableSortingMethods } from '../../../../utils';
import { ColumnsType } from 'antd/es/table';
import {
  BusinessFunctionStats,
  BusinessFunctionWorkaround,
} from '../../../../shared/types/business-functions-workarounds';

const BusinessFunctionWorkarounds = () => {
  const navigate = useNavigate();

  const { locationId } = useParams();
  const { locationName } = useLocationName(locationId || '');

  const { stats, statsLoading, statsError } =
    useLocationBusinessFunctionWorkarounds(locationId || '');

  const columns: ColumnsType<BusinessFunctionStats> = [
    {
      title: 'Business Function',
      dataIndex: 'name',
      key: 'name',
      defaultSortOrder: 'ascend',
      sorter: (a: { name: string }, b: { name: string }) =>
        tableSortingMethods.string(a.name, b.name),
    },
    ...overviewColumns,
  ];

  const extendActions = (record: BusinessFunctionWorkaround) => {
    return (
      <Button
        type="primary-rounded"
        className="w-full text-sm font-semibold min-w-[200px]"
        onClick={() => {
          navigate(
            `/cyber/location-level/${locationId}/business-functions-workarounds/${record.businessFunctionId}`,
          );
        }}
      >
        Review Workarounds
      </Button>
    );
  };

  return (
    <div>
      <TitleBar
        title="Location Business Function Workarounds"
        subtitle={`${locationName} Business Function Overview`}
        brief={`Below is a list of existing Business Functions at the ${locationName} location.`}
      />
      <TableV3
        columns={columns}
        loading={statsLoading}
        data={stats}
        rowKey="businessFunctionId"
        extendActions={extendActions}
        error={statsError}
      />
      <Footer
        backPath={`/cyber/location-level/${locationId}/application-workarounds`}
      />
    </div>
  );
};

export default BusinessFunctionWorkarounds;
